import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { containerApp } from '../../main';
import AppointmentDetails from './appointments/views/list/appointmentDetails';
import AddAppointment from './appointments/addAppointment/addAppointment';
import BlockTimeModal from './appointments/blockTime/blockTimeModal';
import WalkInListModal from './appointments/walkInList/walkInListModal';
import CancelPaymentModal from './payment/cancelPaymentModal';
import ClockInModal from './timeTracker/modals/ClockInModal';
import ConfirmModal from '../common/confirmModal/containers/ConfirmModal';
import MessageModal from '../listeningMode/messages/containers/MessageModal';
import Maintenance from '../common/Maintenance';
import ExtendedClockInModal from './timeTracker/modals/ExtendedClockModal';

class Main extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    marginClass: PropTypes.string,
  }
  static defaultProps = {
    marginClass: '',
  }


  getPageContentClassName() {
    return classNames('c-page-content', {
      'is-sidebar-expanded': this.props.marginClass.includes('expand'),
      'is-sidebar-collapsed': this.props.marginClass === 'collapse',
      'is-container-app': this.props.marginClass.includes('container'),
    });
  }

  render() {
    return (
      <React.Fragment>
        <Maintenance />
        <div className={this.getPageContentClassName()}>
          {this.props.children}
          <div>
            <AppointmentDetails />
            <AddAppointment />
            <BlockTimeModal />
            <WalkInListModal />
            <CancelPaymentModal />
            <ClockInModal display-if={!containerApp.isActive()} />
            <ConfirmModal />
            <MessageModal />
            <ExtendedClockInModal />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Main;
